import { z } from 'zod';
import { BaseErrorSchema } from '../../../../shared/error.schema';
/**
 * Delete SuperAdmin User Request Schema
 * DELETE /api/v2/superadmin-users/:userId
 * Soft deletes a superadmin user (sets deletedAt timestamp)
 */ export const DeleteSuperAdminUserRequestSchema = z.object({
    userId: z.string()
});
/**
 * Delete SuperAdmin User Response Schema
 * Returned on successful user deletion
 */ export const DeleteSuperAdminUserResponseSchema = z.object({
    success: z.boolean()
});
/**
 * Delete SuperAdmin User Error Schema
 * Returned when user deletion fails
 */ export const DeleteSuperAdminUserErrorSchema = BaseErrorSchema;

//# sourceMappingURL=delete-superadmin-user.schema.js.map